const domainReg = /cloud.tencent.*/;
const domains = window.location.hostname.match(domainReg);

export const MAINDOMAIN = domains?.[0];

export const CURDOMAIN = window.location.hostname;
